// Basic email validation helper (frontend)
// Mirrors backend logic for early feedback but defers authoritative check to server.
// If STRICT_EMAIL_VALIDATION is enabled on backend, backend may still reject addresses
// that pass this lightweight client check (e.g., MX or disposable domain). We surface
// server error messages accordingly.

const BASIC_EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;

export function isValidEmailFormat(email) {
  if (!email) return false;
  // Trim and lowercase for comparison; backend also lowercases.
  const normalized = String(email).trim();
  // Reject obvious consecutive dots and leading/trailing dots in local or domain parts.
  if (/^\.|\.$/.test(normalized)) return false;
  if (normalized.includes('..')) return false;
  return BASIC_EMAIL_REGEX.test(normalized);
}

export function normalizeEmail(email) {
  return String(email || '').trim().toLowerCase();
}

export default {
  isValidEmailFormat,
  normalizeEmail,
};
